<span class="container">
  <div #customTrigger><ng-content select="[menuTrigger]"></ng-content></div>
  <button
    #trigger
    rivButton
    [variant]="'ghost'"
    [size]="small ? 'xsmall' : 'medium'"
    [class.rv-hidden]="customTrigger.children.length"
    [menuTrigger]="this"
    [rivTooltip]="showTooltip ? tooltip : undefined"
    [disabled]="disabled"
    [icon]="icon"
    [iconPosition]="'last'"
  >
    <riv-badge
      *ngIf="!!badgeText"
      [size]="'xsmall'"
      [variant]="badgeType"
      class="mr-small"
      >{{ badgeText }}</riv-badge
    >
    <span *ngIf="!!text">{{ text }}</span>
  </button>
</span>

<ng-container *ngIf="showMenu">
  <riv-callout
    *riv-callout
    [anchor]="
      customTrigger.children.length ? customTrigger : trggr.nativeElement
    "
    [preferredPosition]="preferredPosition"
    (keydown)="keydown($event.key)"
    (close)="closeMenu(false)"
    [theme]="light ? 'light' : 'dark'"
    tabindex="-1"
    [showCaret]="showCaret"
    [isModal]="true"
  >
    <div class="options" [class.light]="light" #menuoptions>
      <ng-container *ngIf="!light">
        <ng-container *ngTemplateOutlet="menuItemTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="light">
        <ng-container *ngTemplateOutlet="menuItemLightTemplate"></ng-container>
      </ng-container>
    </div>
  </riv-callout>
</ng-container>
